const dataDeletionUpdatedAt = "07/05/2025";

export const NeighborwhoodDataDeletion = () => {
  return (
    <div>
      <h3>Data Deletion Steps for NeighborWhood mobile application</h3>
      <br />
      Last updated: <b>{dataDeletionUpdatedAt}</b>
      <br />
      <br />
      <p>
        <b>Essencebit SRL</b> (<b>“us”</b>, <b>“we”</b>, or <b>“our”</b>)
        operates the <b>NeighborWhood</b> mobile application (<b>“App”</b>).
        <br />
        This page informs you of the <b>Data Deletion Steps</b>.
        <br />
        <br /> Data Deletion Steps:
        <br />
        <b>(1)</b> Login.
        <br />
        <b>(2)</b> Navigate to <b>Profile</b> screen.
        <br />
        <b>(3)</b> Press on <b>Delete Profile</b> button.
        <br />
        <b>(4)</b> Introduce <b>Nickname</b> into the text field.
        <br />
        <b>(5)</b> Confirm <b>Profile Deletion</b> by pressing on <b>Confirm</b>{" "}
        button.
        <br />
        <br />
        <b>- Contact Us:</b> If you have any questions about this{" "}
        <b>Data Deletion Steps</b>, please contact us at{" "}
        <a href="/">{window.location.origin}</a> by using the chatbot or by
        using the means from <b>"Contact Us"</b> section.
        <br />
        <br />
        <b>- Data Deletion Steps Changes:</b> We may update our{" "}
        <b>Data Deletion Steps</b> from time to time. You are advised to review
        this <b>Data Deletion Steps</b> periodically for any changes. This{" "}
        <b>Data Deletion Steps</b> is effective as of{" "}
        <b>{dataDeletionUpdatedAt}</b> and will remain in effect except with
        respect to any changes in its provisions in the future, which will be in
        effect immediately after being posted on this page.
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
